<template>
	<nk-page commercialAccess="System" class="auto-user-account-modify" :policyClaims="['Accounting_Account_AutoModify']" tabindex="101" startup>
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t('forms.AutoAccounts')"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="h-100 auto-user-account-modify-content">
			<div class="top form-container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8">
						<div class="nfom filter-dropdown mr-3">
							<nk-col-form-group :labelSizes="{ xs: 3 }" :dataSizes="{ xs: 9 }" :labelAligns="{ xs: 'left' }" :label="$t('autoAccount.f.filter-by-user') + ': '">
								<nk-dropdown v-model="selectedUser" :data="usersList" :options="settings.formUserDropdown" :tabindex="100" :disabled="!!settings.selectedUser ? true : null"></nk-dropdown>
							</nk-col-form-group>
							<nk-col-form-group :labelSizes="{ xs: 3 }" :dataSizes="{ xs: 9 }" :labelAligns="{ xs: 'left' }" :label="$t('autoAccount.f.filter-by-form') + ':'">
								<nk-dropdown v-model="selectedForm" :data="forms" :options="settings.formDropdown" :tabindex="101" :disabled="!!settings.filterByForm ? true : null"></nk-dropdown>
							</nk-col-form-group>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom overflow-hidden">
				<nk-stabs :activeTab="activeTab" :tabKeys="groups" :tabindex="101" :scrollable="true" class="h-100" @activeTabChanged="tabId => activeTab = tabId">
					<nk-stab :id="gr" v-for="(gr, grIndex) in groups" :name="$t(`autoAccount.group.${gr}`)" :key="gr">
						<div v-for="(type, typeIndex) in typesInActiveGroup" :key="typeIndex" class="loop nk-card mb-4 p-3 form-container">
							<div class="nform" v-if="activeTab === gr">
								<div class="w-100 row no-gutters" style="border-bottom: 1px solid #5c53c5">
									<div class="col-sm-3 text-right">
										<span v-if="type.isDebtor != null" :class="[type.isDebtor ? 'badge-success' : 'badge-danger'] + ' badge mt-1 mr-1'">{{ $t(`autoAccount.${type.isDebtor ? 'debtor' : 'creditor'}`) }}</span>
									</div>
									<div class="col-sm-6 pt-2 text-center">
										<b>{{ $t(`autoAccount.type.${type.key}`) }}</b>
									</div>
									<div class="col-sm-3 text-left">
										<nk-button class="m-2" :options="enableButton" @click="(b, e) => cardStateHandler(typeIndex, type, e)" :tabindex="201"></nk-button>
									</div>
								</div>
								<div class="w-100">
									<div class="m-2 d-flex">
										<p>{{ $t('autoAccount.linked-accounts') }}:</p>
										<nk-multichoice :options="settings.multiChoiceOptions" :data="allAccounts" :tabindex="200 + (grIndex + 1) * (typeIndex + 1)" :value="accountsWithType(type.key)" :ref="'multiChoice' + typeIndex" @update:modelValue="(arr) => accountsChangedInType(type, typeIndex, arr)" :startup="(grIndex === 0 && typeIndex === 0) ? true : null">
										</nk-multichoice>
									</div>
									<div class="d-flex justify-content-between" v-if="selectedUser">
										<div class="m-2 d-flex align-items-center">
											<p>{{ $t('autoAccount.default-account') }}:</p>
											<nk-dropdown v-model="selectedUser.defaultAccounts[type.key]" :data="accountsWithType(type.key, true)" :options="settings.defaultAccountDropdown" :tabindex="100" @update:modelValue="(item) => defaultAccountChanged(item, type)" v-if="activeAccountTypeRow == type.key"></nk-dropdown>
											<span v-else>{{ (selectedUser && selectedUser.defaultAccounts[type.key] ? `${selectedUser.defaultAccounts[type.key].name} (${selectedUser.defaultAccounts[type.key].accountingCode})` : $t('autoAccount.no-default-account-selected')) }}</span>
										</div>
										<div class="m-2 d-flex align-items-center">
											<p>{{ $t('autoAccount.default-center') }}:</p>
											<nk-dropdown-center v-model="selectedUser.defaultFloatingCenters[type.key]" :options="settings.floatingCenterDropDown" :tabindex="202" v-if="activeAccountTypeRow == type.key" @update:modelValue="(item) => defaultFloatingCenterChanged(item, type)"></nk-dropdown-center>
											<span v-else>{{ (selectedUser && selectedUser.defaultFloatingCenters[type.key] ? `${selectedUser.defaultFloatingCenters[type.key].name} (${selectedUser.defaultFloatingCenters[type.key].code})` : $t('autoAccount.no-default-center-selected')) }}</span>
										</div>
									</div>
									<div class="d-flex justify-content-between" v-else-if="selectedForm">
										<div class="m-2 d-flex align-items-center">
											<p>{{ $t('autoAccount.default-form-account') }}:</p>
											<nk-dropdown v-model="type.defaultAccount" :data="accountsWithType(type.key, true)" :options="settings.defaultAccountDropdown" :tabindex="200" @update:modelValue="(item) => defaultFormAutoAccountChanged(item, type)" v-if="activeAccountTypeRow == type.key"></nk-dropdown>
											<span v-else>{{ type.defaultAccount ? `${type.defaultAccount.name} (${type.defaultAccount.accountingCode})` : $t('autoAccount.no-default-account-selected') }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</nk-stab>
				</nk-stabs>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _, { result } from 'lodash'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import { mapActions, mapGetters } from 'vuex'
	import Table from '~/components/table/grid'
	import TabOrder from '~/statics/taborder-functions'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'

	export default {
		modal: {
			size: 'lg',
			stateUID: 'auto-accounts-modify',
			helpTag: 'AutoAccountModify'
		},
		props: {
			options: { type: Object },
		},
		data() {
			return {
				activeAccountTypeRow: '',
				usersList: null,
				settings: {
					formDropdown: {
						rowIdentifier: 'key',
						searchableFields: ['key', 'title'],
						display: (item) => item.title,
					},
					floatingCenterDropDown: {
						rowIdentifier: 'id',
						searchable: true,
						required: true,
						baseAccountId: null,
						centerLevel: 1,
						remoteSearch: false,
						placeholder: this.$t('autoAccount.choose-center'),
						display: (item) => `${item.name} (${item.accountingCode})`,
						searchableFields: ['name', 'accountingCode'],
						selectorWidth: 350,
						locateSelectorBasedOnDocument: true,
						loadAllIfBaseAccountIsEmpty: false
					},
					formUserDropdown: {
						rowIdentifier: 'id',
						searchableFields: ['firstName', 'lastName'],
						display: (item) => item.firstName + ' ' + item.lastName,
					},
					defaultAccountDropdown: {
						rowIdentifier: 'id',
						searchableFields: ['name'],
						display: (item) => `${item.name} (${item.accountingCode.toLocaleDigits()})`
					},
					multiChoiceOptions: {
						display: (item) => {
							if (item != null) {
								let text = `${item.name} <span class="code">(${item.accountingCode})</span>`

								if (item.user) {
									text += ` <span class="user">(${item.user.normalizedName})</span>`
								}

								return text
							}

							return ''
						},
						editable: false,
						comparer: (a, b) => {
							let userEqual = !!a.user === !!b.user
							let hasUser = !!a.user
							if (
								a.id === b.id &&
								userEqual &&
								(!hasUser || a.user.id === b.user.id)
							) {
								return true
							}

							return false
						},
						dropdown: {
							remoteSearch: false,
							placeholder: this.$t('autoAccount.choose-account'),
							selectorWidth: '400px',
							searchable: true,
							searchableFields: ['name', 'accountingCode'],
							display: (item) => `${item.accountingCode} - ${item.name}`,
							// loadOnMount: false,
							selectorHeight: 400,

							component: {
								type: 'ag-grid',
								options: {
									columnDefs: [
										{
											field: 'rowNumber',
											headerName: '...',
											width: 50,
											pinned: 'right',
										},
										{
											field: 'accountingCode',
											headerName: this.$t('account.selector.table.c.accountingCode'),
											width: 110,
										},
										{
											field: 'name',
											headerName: this.$t('account.selector.table.c.name'),

										},
										{
											field: 'parent',
											headerName: this.$t('account.selector.table.c.parent'),
											contentType: 'enum',
											valueFormatter: data => {
												return data.value?.name ? data.value.name : null
											},
											width: 150
										}
									],
									rowSelection: {
										mode: 'singleRow'
									},
									cellSelectionAggReport: false,
									sideBar: 'none',
									enterToSelect: true,
									doubleClickedToSelect: true,
									pagination: false,
									fitToWidth: false,
								}
							},
						},
					},
					autoAccount: {
						display: (item) => {
							if (item != null) {
								let text = `<span class="code">${item.accountingCode}</span> ${item.name}`

								if (item.user) {
									text += ` <span class="user">(${item.user.normalizedName})</span>`
								}

								return text
							}

							return ''
						},
						editable: false,
						comparer: (a, b) => {
							let userEqual = !!a.user === !!b.user
							let hasUser = !!a.user
							if (
								a.id === b.id &&
								userEqual &&
								(!hasUser || a.user.id === b.user.id)
							) {
								return true
							}

							return false
						},
						dropdown: {
							remoteSearch: false,
							placeholder: this.$t('select-it'),
							selectorWidth: '400px',
							display: (item) => `${item.accountingCode} - ${item.name}`,
							component: {
								type: Table,
								options: {
									searchable: false,
									editable: false,
									activeRowDisabled: true,
									columns: [
										{
											name: 'rowNumber',
											title: '...',
											searchable: false,
											sortable: true,
											editable: false,
											width: '50|>50',
											entering: false,
											pinned: true,
											pinnable: false,
										},
										{
											name: 'accountingCode',
											title: this.$t('account.selector.table.c.accountingCode'),
											width: 110,
											pinnable: false,
											resizable: false,
										},
										{
											name: 'name',
											title: this.$t('account.selector.table.c.name'),
											width: 'auto',
											pinnable: false,
											resizable: false,
										},
									],
								},
							},
						},
					},
					filterByForm: null,
					selectedUser: null
				},
				autoAccounts: null,
				autoFloatingCenters: [],
				autoAccountTypes: null,
				defaultFormAutoAccounts: [],
				activeTab: '',
				originalData: null,
				selectedForm: null,
				selectedUser: null,
				saveAutoAccountButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					icon: 'save',
					handle: (button, page, e) => {
						this.saveData()
					},
					policyClaims: 'Accounting_Account_AutoModify'
				},
				enableButton: {
					title: this.$t('autoAccount.enable-button'),
					isPrimary: true,
					icon: 'check-circle',
				},
			}
		},
		computed: {
			...mapGetters({
				account_leaves: 'accounts/leaves',
				allAccounts: 'accounts/all',
				allForms: 'forms/all',
				findFormByKey: 'forms/findFormByKey',
				currentUser: 'appContext/getUser',
				accountChildren: 'accounts/children'
			}),
			forms() {
				return this.allForms.filter(x => x.part !== 0).map((item) => {
					return _.extend(
						{
							title: this.$t('forms.' + item.key),
						},
						item
					)
				})
			},
			groups() {
				let arr = this.autoAccountTypes || []

				if (this.selectedForm != null) {
					arr = arr.filter(
						(t) =>
							this.selectedForm.types.findIndex((ft) => ft.key === t.key) > -1
					)
				}

				let groups = arr.reduce((arr, current) => {
					if (arr.filter((x) => x === current.group).length === 0) {
						arr.push(current.group)
					}

					return arr
				}, [])

				// if (this.activeTab != '' && groups.length && groups.indexOf(this.activeTab) === -1) {
				// 	this.activeTab = groups[0]
				// }

				return groups
			},
			typesInActiveGroup() {
				let arr = this.autoAccountTypes || []
				let types = arr.filter((x) => x.group === this.activeTab)
				if (!this.selectedForm) {
					this.defer(() => {
						$(this.$el).find('[startup]').focus()
						this.registerTabOrders()
					}, 100)
					return types
				}
				else {
					let filteredTypes = []
					this.selectedForm.types.forEach(element => {
						let t = types.find((t) => t.key === element.key)
						if (t) {
							// t.isDebtor = !!element.isDebtor
							filteredTypes.push(_.merge({}, t, { formAutoAccountTypeId: element.id, isDebtor: element.isDebtor, defaultAccount: element.defaultAccount }))
						}
					})
					this.defer(() => {
						$(this.$el).find('[startup]').focus()
						this.registerTabOrders()
					}, 100)
					return filteredTypes
				}
			},
		},
		watch: {
			options: {
				deep: true,
				handler(val) {
					this.cloneSettings(val)
				},
			},
		},
		mounted() {
			this.prepareWindow(this.$t('autoAccount.userTitle'), [
				this.saveAutoAccountButton,
			])

			this.fetchData().then(() => {
				this.activeTab = this.groups[0]
				this.defer(() => {
					$(this.$el).find('[startup]').focus()
					this.registerTabOrders()
				}, 100)
				this.getAllUsers()
			})
		},
		created() {
			this.cloneSettings(this.options)
		},
		methods: {
			...mapActions('autoAccounts', {
				refresh_auto_accounts: 'refresh',
			}),
			...mapActions('forms', {
				refresh_forms: 'refresh',
			}),
			getAllUsers() {
				post(Endpoints.getUrl('user.list'))
					.then((result) => {
						this.usersList = result.data.items
						for (var user of this.usersList) {
							user.defaultAccounts = []
							user.defaultFloatingCenters = []
							for (var type of this.autoAccountTypes) {
								user.defaultAccounts[type.key] = this.autoAccounts.find(x => x.autoAccountTypeKey == type.key && x.autoAccountUserId == user.id && x.isDefault)
								let fc = this.autoFloatingCenters.find(x => x.autoAccountType.id == type.id && x.user.id == user.id)
								user.defaultFloatingCenters[type.key] = fc ? fc.floatingCenter : null
							}
							if (user.id == this.currentUser.id) {
								if (this.selectedForm) {
									if (this.autoAccounts.findIndex(x => x.autoAccountUserId === user.id && this.selectedForm.types.findIndex(type => type.key === x.autoAccountTypeKey) > -1) > -1)
										this.selectedUser = user
								} else {
									if (this.autoAccounts.findIndex(x => x.autoAccountUserId === user.id) > -1)
										this.selectedUser = user
								}
							}
						}
					})
					.catch(() => { })
			},
			cardStateHandler(index, type, e) {
				e.preventDefault()
				for (let i in this.$refs) {
					if (this.$refs[i][0] && i.indexOf('multiChoice') > -1) {
						this.$refs[i][0].editHandler(false)
					}
				}
				this.$refs['multiChoice' + index][0].editHandler(true)
				this.activeAccountTypeRow = type.key

				if (this.selectedUser && this.selectedUser.defaultAccounts[type.key])
					this.settings.floatingCenterDropDown.baseAccountId = this.selectedUser.defaultAccounts[type.key].id
				else
					this.settings.floatingCenterDropDown.baseAccountId = this.accountsWithType(type.key, true).map(x => x.id)
			},
			cloneSettings(options) {
				this.settings = _.extend({}, this.settings, options)
				if (this.settings.filterByForm) {
					this.selectedForm = _.head(
						this.allForms.filter((x) => x.key === this.settings.filterByForm)
					)
				}
			},
			fetchData() {
				const showError = (msg) => {
					return dialog({
						title: this.$t('autoAccount.m.fetch.error'),
						body: msg,
						type: 'error',
					})
				}

				let wait = this.$wait(this.$el)

				return new Promise((resolve, reject) => {
					this.defer(() => {
						post(Endpoints.getUrl('accounts.auto.types'))
							.then((result) => {
								this.autoAccountTypes = result.data.items
							})
							.then(() => post(Endpoints.getUrl('accounts.auto.list')))
							.then((result) => {
								this.autoAccounts = result.data.items
								this.autoFloatingCenters = result.data.autoFloatingCenters
							})
							.then(() => {
								this.$nextTick(() => {
									wait.end()
									resolve()
								})
							})
							.catch((result) => {
								showError(result.message)
								wait.end()
								reject(new Error(result.message))
							})
					}, 500)
				})
			},
			saveData() {
				var autoAccountItems = this.autoAccounts.filter((x) => x.rowState !== 'unchanged')
				var autoFloatingCenterItems = this.autoFloatingCenters.filter((x) => x.rowState !== 'unchanged')

				if (autoAccountItems.length === 0 && autoFloatingCenterItems.length === 0 && this.defaultFormAutoAccounts.length === 0) {
					this.$toast(this.$t('autoAccount.m.save.success'), { type: 'success' })
					this.resolve()
					return
				}

				var wait = this.$wait(this.$el)
				post(Endpoints.getUrl('accounts.auto.modify'), { autoAccounts: autoAccountItems, autoFloatingCenters: autoFloatingCenterItems, defaultFormAutoAccounts: this.defaultFormAutoAccounts })
					.then((result) => {
						wait.end()
						this.refresh_auto_accounts({ force: true })
						if (this.defaultFormAutoAccounts.length) {
							this.refresh_forms({ force: true }).then(x => {
								this.selectedForm = this.findFormByKey(this.selectedForm.key)
							})
						}
						this.$toast(this.$t('autoAccount.m.save.success'), { type: 'success' })
						if (this.settings.filterByForm) {
							this.resolve()
						} else {
							this.fetchData().then(() => {
								this.activeTab = this.groups[0]
								this.defer(() => {
									$(this.$el).find('[startup]').focus()
									this.registerTabOrders()
								}, 100)
							})
						}
					})
					.catch(() => {
						wait.end()
					})
			},
			registerTabOrders() {
				TabOrder.subscribeKeys(this.grandParentType(), this)
			},
			accountsWithType(typeKey, getSelectable = false) {
				let arr = this.autoAccounts || []
				let accounts = arr.filter(
					(x) => x.autoAccountTypeKey === typeKey && x.rowState !== 'deleted'
				)
				if (this.selectedUser) {
					accounts = accounts.filter(
						(x) => x.autoAccountUserId === this.selectedUser.id
					)
				} else {
					accounts = accounts.filter(
						(x) => !x.autoAccountUserId
					)
				}

				if (getSelectable) {
					const selectableAccounts = []

					accounts.forEach((autoAccount) => {
						if (autoAccount.hasChild) {
							selectableAccounts.push(...this.accountChildren(autoAccount.id, false).filter(account => !account.hasChild))
						}
						else
							selectableAccounts.push(autoAccount)
					})

					return selectableAccounts
				}
				else
					return accounts
			},
			accountsChangedInType(type, index, arr) {
				let origins = this.accountsWithType(type.key)

				for (let item of origins) {
					if (
						arr.findIndex((o) => this.settings.autoAccount.comparer(o, item)) === -1
					) {
						item.rowState = 'deleted'
					}
				}

				let temp = [...this.autoAccounts]
				for (let item of arr) {
					if (
						origins.findIndex((o) =>
							this.settings.autoAccount.comparer(o, item)
						) === -1
					) {
						let obj = {
							autoAccountId: emptyId,
							autoAccountTypeKey: type.key,
							rowState: 'new',
							isDefault: false
						}
						if (this.selectedUser) {
							obj.autoAccountUserId = this.selectedUser.id
						}
						temp.push(_.extend(item, obj))
					}
				}
				this.autoAccounts = temp
				this.settings.floatingCenterDropDown.baseAccountId = this.accountsWithType(type.key, true).map(x => x.id)

				if (this.selectedUser) {
					let defaultAccount = this.selectedUser.defaultAccounts[type.key]
					if (defaultAccount && this.accountsWithType(type.key, true).findIndex(x => x.id == defaultAccount.id) === -1) {
						this.selectedUser.defaultAccounts[type.key] = null
						this.selectedUser.defaultFloatingCenters[type.key] = null
					}
				}
			},
			defaultAccountChanged(account, type) {
				let accounts = this.accountsWithType(type.key, true)
				for (var acc of accounts) {
					if (acc.isDefault === true && acc.id !== (account || {}).id && acc.rowState === 'unchanged')
						acc.rowState = 'changed'
					acc.isDefault = false
				}
				if (account) {
					let linkedAccounts = this.accountsWithType(type.key)

					let autoAccount = linkedAccounts.find(x => x.id == account.id)

					if (!autoAccount) {
						linkedAccounts.push(account)
						this.accountsChangedInType(type, 0, linkedAccounts)
					}

					linkedAccounts = this.accountsWithType(type.key)
					autoAccount = linkedAccounts.find(x => x.id == account.id)
					autoAccount.isDefault = true
					autoAccount.rowState = autoAccount.rowState === 'new' ? 'new' : 'changed'
					if (this.settings.floatingCenterDropDown.baseAccountId != account.id)
						this.settings.floatingCenterDropDown.baseAccountId = account.id
				} else {
					this.settings.floatingCenterDropDown.baseAccountId = accounts.map(x => x.id)

					let foundIndex = this.autoFloatingCenters.findIndex(x => x.user.id == this.selectedUser.id && x.autoAccountType.id == type.id)

					if (foundIndex > -1) {
						if (this.autoFloatingCenters[foundIndex].rowState === 'new')
							this.autoFloatingCenters[foundIndex] = null
						else
							this.autoFloatingCenters[foundIndex].rowState = 'deleted'

						this.selectedUser.defaultFloatingCenters[type.key] = null
					}
				}
			},
			defaultFloatingCenterChanged(fc, type) {
				if (!this.selectedUser)
					return
				let findIndex = this.autoFloatingCenters.findIndex(x => x.user.id == this.selectedUser.id && x.autoAccountType.id == type.id)

				// وقتیکه شناور خالی می شود، اگر قبلا برای این نوع حساب شناور پیش فرض انتخاب شده باشد به وضعیت حذف شده تغییر یابد و اگر جدیدا اضافه شده از لیست حذف شود
				if (!fc && findIndex > -1) { // selected item is empty but autoAccountType exist
					if (this.autoFloatingCenters[findIndex].rowState === 'new')
						this.autoFloatingCenters.splice(findIndex, 1)
					else
						this.autoFloatingCenters[findIndex].rowState = 'deleted'
				} else if (fc) {
					if (findIndex === -1) {
						this.autoFloatingCenters.push({
							autoAccountType: { id: type.id, key: type.key },
							user: { id: this.selectedUser.id, firstName: this.selectedUser.firstName, lastName: this.selectedUser.lastName },
							floatingCenter: fc,
							rowState: 'new'
						})
					} else {
						this.autoFloatingCenters[findIndex].rowState = this.autoFloatingCenters[findIndex].rowState == 'new' ? 'new' : 'changed'
						this.autoFloatingCenters[findIndex].floatingCenter = fc
					}
				}
			},
			defaultFormAutoAccountChanged(account, type) {
				if (!this.selectedForm)
					return

				let findIndex = this.defaultFormAutoAccounts.findIndex(x => x.id == type.formAutoAccountTypeId)

				// وقتیکه حساب پیش فرض خالی می شود، اگر قبلا برای این نوع حساب، حساب پیش فرض انتخاب شده باشد به وضعیت حذف شده تغییر یابد و اگر جدیدا اضافه شده از لیست حذف شود
				if (findIndex == -1) {
					this.defaultFormAutoAccounts.push({
						id: type.formAutoAccountTypeId,
						defaultAccount: account,
						rowState: 'changed'
					})
				} else {
					this.defaultFormAutoAccounts[findIndex].defaultAccount = account
					this.defaultFormAutoAccounts[findIndex].rowState = 'changed'
				}
			}
		},
	}
</script>
<style>
	.auto-user-account-modify-content {
		display: flex;
		width: 100%;
		flex-direction: column;
	}

	.auto-user-account-modify-content .top {
		flex: 0 0 40px;
	}

	.auto-user-account-modify-content .bottom {
		flex: 1 1 100%;
	}

	.auto-user-account-modify .nform {
		width: 100%;
		height: 100%;
		align-items: flex-start;
		align-content: flex-start;
	}

	.auto-user-account-modify .nform .nfield {
		grid-template-columns: 230px 1fr;
	}

	.auto-user-account-modify .nform:not(.filter-dropdown) {
		overflow-x: hidden;
		overflow-y: auto;
		display: flex;
	}

	.auto-user-account-modify .nk-multichoice .row {
		height: auto;
		min-height: 20px;
	}

	.auto-user-account-modify .nfield-data-inner {
		display: flex;
	}

	.auto-user-account-modify .mc {
		flex-grow: 1;
	}

	.auto-user-account-modify .badge {
		height: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 60px;
	}

	.auto-user-account-modify .button,
	.auto-user-account-modify .m-dropdown-input {
		height: 30px;
	}

	.auto-user-account-modify .loop {
		display: flex;
		padding: 15px 0;
	}

	.auto-user-account-modify .nfield.double {
		flex-grow: 1;
	}

	.auto-user-account-modify .mc-input {
		background: transparent;
	}

	.auto-user-account-modify i:hover {
		cursor: pointer;
	}

	.auto-user-account-modify .nk-stabs .nk-stabs-panels.scrollable {
		overflow-y: auto;
	}

	.auto-user-account-modify .nform {
		display: flex !important;
		flex-direction: column;
	}

	.auto-user-account-modify p {
		display: flex;
		align-items: center;
		height: 100%;
		margin-bottom: 0;
		padding-left: 5px;
		margin-bottom: 0 !important;
	}
</style>
